import { BaseUrlFormatter } from "../../../base";
export class LeagueNavUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(request) {
        return `v2/nav/leagues/${request.leagueId}`;
    }
}
//# sourceMappingURL=LeagueNavUrlFormatter.js.map